<template>
  <pbc-modal @close='$emit("close")' :disable-title="true">
    <template #default='{}'>
      <auth :login-state='loginState' @close='$emit("close")'>

        <button v-if='enableGuest' class="p-2 mt-4 flex-flex-row w-64 bg-blue-800 flex flex-row" @click='$emit("guest")'>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 481.91 536.43" class="content-rotate">
            <g id="ninja">
            <path d="M204.39,286.06c2.16-7.45,4.65-14.78,7.29-22.07s5.5-14.5,8.55-21.65a374.29,374.29,0,0,1,20.88-41.85,245.82,245.82,0,0,1,27.46-38.61,163.84,163.84,0,0,1,17.27-17q4.7-3.93,9.79-7.48l2.57-1.73c.87-.57,1.76-1.11,2.64-1.67s1.79-1.07,2.69-1.6l1.36-.78c.46-.26.94-.51,1.42-.76a95.52,95.52,0,0,1,24-8.52A140.36,140.36,0,0,1,355,119.43c16.39-.58,32.38,1,47.9,2.92,7.75.94,15.41,2,22.84,2.79,3.72.4,7.38.75,10.91,1a81.18,81.18,0,0,0,10,0,32.54,32.54,0,0,0,4.07-.54c.57-.13,1.1-.26,1.55-.41a7.27,7.27,0,0,0,1.06-.44c.52-.28.54-.45.35-.36s-.43.37-.44.26,0-.2,0-.45,0-.29,0-.44,0-.35,0-.58a21.37,21.37,0,0,0-.34-3.24,56.22,56.22,0,0,0-2.38-8.65,14.87,14.87,0,1,1,28.06-9.83c.11.32.22.65.31,1l0,.11a83.27,83.27,0,0,1,2.7,13.91,47.23,47.23,0,0,1,.12,8.3c0,.74-.15,1.54-.24,2.31s-.24,1.58-.42,2.42a30.68,30.68,0,0,1-1.53,5.12,28.42,28.42,0,0,1-2.74,5.22,25.61,25.61,0,0,1-4,4.64,28.64,28.64,0,0,1-9.41,5.72,39.56,39.56,0,0,1-8.56,2.08,61.75,61.75,0,0,1-7.46.46,106,106,0,0,1-13.15-.92c-4.15-.52-8.14-1.18-12.07-1.87-7.84-1.39-15.4-2.94-22.9-4.37-15-2.85-29.68-5.29-44.19-5.74a120,120,0,0,0-21.36,1.07,77.87,77.87,0,0,0-19.94,5.55c-3.15,1.41-6.4,3-9.5,4.77s-6.17,3.73-9.16,5.81a147.85,147.85,0,0,0-17.05,14,233.77,233.77,0,0,0-29.28,34.4,366.27,366.27,0,0,0-24,39.09q-5.42,10.16-10.31,20.63c-3.25,7-6.35,14-9.13,21.21h0a.55.55,0,0,1-.71.31A.56.56,0,0,1,204.39,286.06Z" fill="#ff5a5a"/>
            <path d="M293.53,245.72c-11.44-6.25-22.54-13.11-33.45-20.35s-21.54-15-31.83-23.29a289.44,289.44,0,0,1-29.5-27.15,190.42,190.42,0,0,1-13.27-15.76c-2.08-2.8-4.1-5.67-6-8.67s-3.73-6.11-5.43-9.34l-1.24-2.46-1.18-2.51c-.75-1.65-1.42-3.24-2.09-4.9q-2-4.93-3.67-10.1a114.68,114.68,0,0,1-4.79-21.71,88.51,88.51,0,0,1,.32-23.58A76.53,76.53,0,0,1,169,52.23a79.11,79.11,0,0,1,6.7-10.74A86.7,86.7,0,0,1,184,32a99.38,99.38,0,0,1,19.22-14.75A132.69,132.69,0,0,1,224,7.27,179.36,179.36,0,0,1,245.36.73l.31-.08a22.84,22.84,0,1,1,7.82,44.9c-11.23,1.2-22.05,3.55-31.43,7.55S204.91,62.65,199.68,70a42.12,42.12,0,0,0-6.06,12.53,56.45,56.45,0,0,0-2.22,15.1,84.32,84.32,0,0,0,1.44,16.6c.51,2.83,1.15,5.68,1.89,8.53.35,1.41.78,2.87,1.17,4.25l.58,2,.65,2c.91,2.7,2,5.4,3.13,8.1s2.5,5.38,3.9,8a169,169,0,0,0,9.5,15.73,273.53,273.53,0,0,0,23.55,29.62c8.56,9.47,17.69,18.55,27.19,27.29S283.74,237,294,245h0a.46.46,0,0,1,.08.64A.45.45,0,0,1,293.53,245.72Z" fill="#ff5a5a"/>
            <circle cx="191.21" cy="345.22" r="191.21" fill="#fff"/>
            <circle cx="191.21" cy="345.22" r="182.4" fill="#1a202c"/>
            <path d="M59.57,285.45H322.84a0,0,0,0,1,0,0v25.91a54.07,54.07,0,0,1-54.07,54.07H113.65a54.07,54.07,0,0,1-54.07-54.07V285.45a0,0,0,0,1,0,0Z" fill="#ffc064"/>
            <path d="M148.52,335.39a8,8,0,0,1,5.42-7.55c-2.73-5-7.4-8.26-12.71-8.26-8.43,0-15.27,8.28-15.27,18.48s6.84,18.48,15.27,18.48c6.92,0,12.76-5.57,14.63-13.21A8,8,0,0,1,148.52,335.39Z" fill="#1a202c"/>
            <line x1="125.45" y1="319.85" x2="164.99" y2="319.85" fill="none" stroke="#1a202c" stroke-linecap="round" stroke-miterlimit="10" stroke-width="21.79"/>
            <path d="M243.39,335.39a8,8,0,0,1,5.42-7.55c-2.73-5-7.4-8.26-12.71-8.26-8.43,0-15.27,8.28-15.27,18.48s6.84,18.48,15.27,18.48c6.91,0,12.75-5.57,14.63-13.21A8,8,0,0,1,243.39,335.39Z" fill="#1a202c"/>
            <line x1="213.71" y1="319.85" x2="253.25" y2="319.85" fill="none" stroke="#1a202c" stroke-linecap="round" stroke-miterlimit="10" stroke-width="21.79"/>
            <path d="M18.84,285.45H363.58a182.13,182.13,0,0,0-31.26-55.8H50.1A182.13,182.13,0,0,0,18.84,285.45Z" fill="#ff5a5a"/>
            </g>
          </svg>

          <span class="text-white ml-3 font-bold">Continue as Guest</span>
        </button>

      </auth>
    </template>
    <template #controls='{close}'>
      <div class="mx-2 mb-2 pt-2 flex justify-center border-t border-solid border-grey-500">
        <pbc-button @click="close">
          <close class="mx-2"/>
          <span class="mr-2">Cancel</span>
        </pbc-button>
      </div>
    </template>
  </pbc-modal>
</template>
<script>
import Auth from '@ui/molecules/Auth.vue';
import PbcModal from '@ui/molecules/PbcModal.vue';
import Close from '@icons/Close.vue';

export default {
  props:{
    loginState:{
      type: String,
      default: ""
    },
    enableGuest: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    //TODO: ayoba anonymous hack
    if (this.isAyoba) {
      setTimeout( () => {
        this.$emit("guest");
      }, 0);
    }
  },
  computed: {
    isAyoba() {
      return this.$store.state.isAyoba;
    }
  },
  components:{
    Auth,
    PbcModal,
    Close
  },
}
</script>
